<template>
  <div class="MasterclassList">
    <vv-hero :title="$t('home.formations')" :height="200" :asset="masterclassHero" :inverted="true" />

    <mq-layout :mq="['desktop']" class="mq-header header-not-mobile">
      <!-- Pending/Running masterclasses -->
      <div class="pl-2" v-if="pendingMasterclasses.length">
        <vv-section-title class="SectionTitle">{{ t('runningMasterclasses') }}</vv-section-title>
        <swiper :options="swiperOptions" class="Swiper">
          <swiper-slide v-for="masterclass of pendingMasterclasses" :key="masterclass.id" class="content">
            <content-tile :masterclass-id="masterclass.id" @click="onTileClick" :is-pending="true" />
          </swiper-slide>
        </swiper>
      </div>

      <!-- Decouverte des regions masterclasses -->
      <div class="pl-2 pr-2">
        <img src="@/assets/DR.png" class="picto"/>

        <vv-section-title class="SectionTitle">{{ t('paysMasterclasses') }}</vv-section-title>
        <div v-if="discoverRegionMasterclasses.length" :class="{ List__Container: true, 'List__Container--small': $mq === 'mobile' }">
          <div
            v-for="masterclass of discoverRegionMasterclasses"
            :key="masterclass.id"
            :style="{ 'padding-left': ['desktop'].includes($mq) ? 5 : 0 }"
            :class="{ ContentTile: true }"
          >
            <content-tile :masterclass-id="masterclass.id" @click="onTileClick" classColor="orange-color" />
          </div>  
        </div>
        <div v-else class="loading-spinner">
          <Spinner />
        </div>
      </div>

      <!-- Decouverte Cepage masterclasses -->
      <div class="pl-2 pr-2">
        <img src="@/assets/DC.png" class="picto"/>

        <vv-section-title class="SectionTitle">{{ t('vignesMasterclasses') }}</vv-section-title>
        <div v-if="discoverCepageMasterclasses.length" :class="{ List__Container: true, 'List__Container--small': $mq === 'mobile' }">
          <div
            v-for="masterclass of discoverCepageMasterclasses"
            :key="masterclass.id"
            :style="{ 'padding-left': ['desktop'].includes($mq) ? 5 : 0 }"
            :class="{ ContentTile: true }"
          >
            <content-tile :masterclass-id="masterclass.id" @click="onTileClick" classColor="vert-color" />
          </div>  
        </div>
        <div v-else class="loading-spinner">
          <Spinner />
        </div>
      </div>

      <!-- Vin et vous masterclasses -->
      <div class="pl-2 pr-2">
        <img src="@/assets/WY.png" class="picto"/>

        <vv-section-title class="SectionTitle">{{ t('degustateurMasterclasses') }}</vv-section-title>
        <div v-if="wineAndYouMasterclasses.length" :class="{ List__Container: true, 'List__Container--small': $mq === 'mobile' }">
          <div
            v-for="masterclass of wineAndYouMasterclasses"
            :key="masterclass.id"
            :style="{ 'padding-left': ['desktop'].includes($mq) ? 5 : 0 }"
            :class="{ ContentTile: true }"
          >
            <content-tile :masterclass-id="masterclass.id" @click="onTileClick" classColor="bleu-color" />
          </div>  
        </div>
        <div v-else class="loading-spinner">
          <Spinner />
        </div>
      </div>

      <!-- Wine masterclasses -->
      <div class="pl-2 pr-2">
        <img src="@/assets/EV.png" class="picto"/>

        <vv-section-title class="SectionTitle">{{ t('vignificationMasterclasses') }}</vv-section-title>
        <div v-if="wineMasterclasses.length" :class="{ List__Container: true, 'List__Container--small': $mq === 'mobile' }">
          <div
            v-for="masterclass of wineMasterclasses"
            :key="masterclass.id"
            :style="{ 'padding-left': ['desktop'].includes($mq) ? 5 : 0 }"
            :class="{ ContentTile: true }"
          >
            <content-tile :masterclass-id="masterclass.id" @click="onTileClick" classColor="rouge-color" />
          </div>  
        </div>
        <div v-else class="loading-spinner">
          <Spinner />
        </div>
      </div>
    </mq-layout>

    <mq-layout :mq="['mobile', 'tablet']" class="mq-header header-mobile">
      <!-- Pending/Running masterclasses -->
      <div>
        <div class="titleMasterclass">{{ t('runningMasterclasses') }}</div>
        <div class="masterclass" v-if="pendingMasterclasses.length" :class="{active : !displayPendingMasterclasses}">
          <div v-if="displayPendingMasterclasses" class="body">
            <div class="bodyMasterclass">
              <div v-for="masterclass of pendingMasterclassesLess" :key="masterclass.id" class="itemsMasterclass">
                <img :src="masterclass.tileImage" class="imageMasterclass" @click="onTileClick(masterclass.id)">
                <div v-if="isLocked(masterclass.id) && !masterclassLock(masterclass.id)">
                  <img class="LockedOverlay" src="@/assets/Cadenas@2x.png"/>
                </div>
                <div v-if="masterclassLock(masterclass.id)">
                  <img class="LockedOverlay" src="@/assets/time-glass.png" />
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="bodyMasterclass">
              <div v-for="masterclass of pendingMasterclasses" :key="masterclass.id" class="itemsMasterclass">
                <img :src="masterclass.tileImage" class="imageMasterclass" @click="onTileClick(masterclass.id)">
                <div v-if="isLocked(masterclass.id) && !masterclassLock(masterclass.id)">
                  <img class="LockedOverlay" src="@/assets/Cadenas@2x.png"/>
                </div>
                <div v-if="masterclassLock(masterclass.id)">
                  <img class="LockedOverlay" src="@/assets/time-glass.png" />
                </div>
              </div>
            </div>
          </div>
          <div v-if="pendingMasterclasses.length > 2">
            <div v-if="displayPendingMasterclasses" class="showMore" @click="displayPendingMasterclasses = false">Voir plus</div>
            <div v-else @click="displayPendingMasterclasses = true" class="showLess">Voir moins</div>
          </div>
        </div>
        <div v-else class="loading-spinner">
          <Spinner />
        </div>
      </div>

      <!-- Decouverte des regions masterclasses -->

      <div>
        <div class="titleMasterclass">{{ t('paysMasterclasses') }}</div>
        <div class="masterclass" v-if="discoverRegionMasterclasses.length" :class="{active : !displayMasterclassRegions}">
          <div v-if="displayMasterclassRegions" class="body">
            <div class="bodyMasterclass">
              <div v-for="masterclass of discoverRegionMasterclassesLess" :key="masterclass.id" class="itemsMasterclass">
                <img :src="masterclass.tileImage" class="imageMasterclass" @click="onTileClick(masterclass.id)">
                <div v-if="isLocked(masterclass.id) && !masterclassLock(masterclass.id)">
                  <img class="LockedOverlay" src="@/assets/Cadenas@2x.png"/>
                </div>
                <div v-if="masterclassLock(masterclass.id)">
                  <img class="LockedOverlay" src="@/assets/time-glass.png" />
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="bodyMasterclass">
              <div v-for="masterclass of discoverRegionMasterclasses" :key="masterclass.id" class="itemsMasterclass">
                <img :src="masterclass.tileImage" class="imageMasterclass" @click="onTileClick(masterclass.id)">
                <div v-if="isLocked(masterclass.id) && !masterclassLock(masterclass.id)">
                  <img class="LockedOverlay" src="@/assets/Cadenas@2x.png"/>
                </div>
                <div v-if="masterclassLock(masterclass.id)">
                  <img class="LockedOverlay" src="@/assets/time-glass.png" />
                </div>
              </div>
            </div>
          </div>
          <div v-if="discoverRegionMasterclasses.length > 2">
            <div v-if="displayMasterclassRegions" class="showMore" @click="displayMasterclassRegions = false">Voir plus</div>
            <div v-else @click="displayMasterclassRegions = true" class="showLess">Voir moins</div>
          </div>
        </div>
        <div v-else class="loading-spinner">
          <Spinner />
        </div>
      </div>


      <!-- Decouverte Cepage masterclasses -->
      <div>
        <div class="titleMasterclass">{{ t('vignesMasterclasses') }}</div>
        <div class="masterclass" v-if="discoverCepageMasterclasses.length" :class="{active : !displayMasterclassCepage}">
          <div v-if="displayMasterclassCepage">
            <div class="bodyMasterclass">
              <div v-for="masterclass of discoverCepageMasterclassesLess" :key="masterclass.id" class="itemsMasterclass">
                <img :src="masterclass.tileImage" class="imageMasterclass" @click="onTileClick(masterclass.id)">
                <div v-if="isLocked(masterclass.id) && !masterclassLock(masterclass.id)">
                  <img class="LockedOverlay" src="@/assets/Cadenas@2x.png"/>
                </div>
                <div v-if="masterclassLock(masterclass.id)">
                  <img class="LockedOverlay" src="@/assets/time-glass.png" />
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="bodyMasterclass">
              <div v-for="masterclass of discoverCepageMasterclasses" :key="masterclass.id" class="itemsMasterclass">
                <img :src="masterclass.tileImage" class="imageMasterclass" @click="onTileClick(masterclass.id)">
                <div v-if="isLocked(masterclass.id) && !masterclassLock(masterclass.id)">
                  <img class="LockedOverlay" src="@/assets/Cadenas@2x.png"/>
                </div>
                <div v-if="masterclassLock(masterclass.id)">
                  <img class="LockedOverlay" src="@/assets/time-glass.png" />
                </div>
              </div>
            </div>
          </div>
          <div v-if="discoverCepageMasterclasses.length > 2">
            <div v-if="displayMasterclassCepage" class="showMore" @click="displayMasterclassCepage = false">Voir plus</div>
            <div v-else @click="displayMasterclassCepage = true" class="showLess">Voir moins</div>
          </div>
        </div>
        <div v-else class="loading-spinner">
          <Spinner />
        </div>
      </div>

      <!-- Vin et vous masterclasses -->
      <div>
        <div class="titleMasterclass">{{ t('degustateurMasterclasses') }}</div>
        <div class="masterclass" v-if="wineAndYouMasterclasses.length" :class="{active : !displaywineAndYouMasterclasses}">
          <div v-if="displaywineAndYouMasterclasses">
            <div class="bodyMasterclass">
              <div v-for="masterclass of wineAndYouMasterclassesLess" :key="masterclass.id" class="itemsMasterclass">
                <img :src="masterclass.tileImage" class="imageMasterclass" @click="onTileClick(masterclass.id)">
                <div v-if="isLocked(masterclass.id) && !masterclassLock(masterclass.id)">
                  <img class="LockedOverlay" src="@/assets/Cadenas@2x.png"/>
                </div>
                <div v-if="masterclassLock(masterclass.id)">
                  <img class="LockedOverlay" src="@/assets/time-glass.png" />
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="bodyMasterclass">
              <div v-for="masterclass of wineAndYouMasterclasses" :key="masterclass.id" class="itemsMasterclass">
                <img :src="masterclass.tileImage" class="imageMasterclass" @click="onTileClick(masterclass.id)">
                <div v-if="isLocked(masterclass.id) && !masterclassLock(masterclass.id)">
                  <img class="LockedOverlay" src="@/assets/Cadenas@2x.png"/>
                </div>
                <div v-if="masterclassLock(masterclass.id)">
                  <img class="LockedOverlay" src="@/assets/time-glass.png" />
                </div>
              </div>
            </div>
          </div>
          <div v-if="wineAndYouMasterclasses.length > 2">
            <div v-if="displaywineAndYouMasterclasses" class="showMore" @click="displaywineAndYouMasterclasses = false">Voir plus</div>
            <div v-else @click="displaywineAndYouMasterclasses = true" class="showLess">Voir moins</div>
          </div>
        </div>
        <div v-else class="loading-spinner">
          <Spinner />
        </div>
      </div>

      <!-- Wine masterclasses -->
      <div>
        <div class="titleMasterclass">{{ t('vignificationMasterclasses') }}</div>
        <div class="masterclass" v-if="wineMasterclasses.length" :class="{active : !displayVinificationMasterclass}">
          <div v-if="displayVinificationMasterclass">
            <div class="bodyMasterclass">
              <div v-for="masterclass of wineMasterclassesLess" :key="masterclass.id" class="itemsMasterclass">
                <img :src="masterclass.tileImage" class="imageMasterclass" @click="onTileClick(masterclass.id)">
                <div v-if="isLocked(masterclass.id) && !masterclassLock(masterclass.id)">
                  <img class="LockedOverlay" src="@/assets/Cadenas@2x.png"/>
                </div>
                <div v-if="masterclassLock(masterclass.id)">
                  <img class="LockedOverlay" src="@/assets/time-glass.png" />
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="bodyMasterclass">
              <div v-for="masterclass of wineMasterclasses" :key="masterclass.id" class="itemsMasterclass">
                <img :src="masterclass.tileImage" class="imageMasterclass" @click="onTileClick(masterclass.id)">
                <div v-if="isLocked(masterclass.id) && !masterclassLock(masterclass.id)">
                  <img class="LockedOverlay" src="@/assets/Cadenas@2x.png"/>
                </div>
                <div v-if="masterclassLock(masterclass.id)">
                  <img class="LockedOverlay" src="@/assets/time-glass.png" />
                </div>
              </div>
            </div>
          </div>
          <div v-if="wineMasterclasses.length > 2">
            <div v-if="displayVinificationMasterclass" class="showMore" @click="displayVinificationMasterclass = false">Voir plus</div>
            <div v-else @click="displayVinificationMasterclass = true" class="showLess">Voir moins</div>
          </div>
        </div>
        <div v-else class="loading-spinner">
          <Spinner />
        </div>
      </div>

    </mq-layout>
  </div>
</template>

<script>
import _get from 'lodash/get'
import { mapGetters } from 'vuex'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

import { getHydratedUser } from '@/helpers/userHelper'
import { getThemePercentage } from '@/helpers/userCompletion'
import userMixin from '@/mixins/user'
import contentMixin from '@/mixins/content'

import { VvHero, VvSectionTitle, VvSectionTitleMobile } from '@/components/common'
import ContentTile from '@/components/masterclass/ContentTile'
import Spinner from '@/components/layout/Spinner'


export default {
  name: 'MasterclassList',
  mixins: [userMixin, contentMixin],
  components: {
    VvHero,
    VvSectionTitle,
    VvSectionTitleMobile,
    ContentTile,
    Swiper,
    SwiperSlide,
    Spinner
  },
  data() {
    return {
      slidesPerView: 3.5,
      spaceBetween: 30,
      displayPendingMasterclasses: true,
      displayMasterclassRegions: true,
      displayMasterclassCepage: true,
      displaywineAndYouMasterclasses: true,
      displayVinificationMasterclass: true
    }
  },
  computed: {
    ...mapGetters([
      'getThemes',
      'getThemeById'
    ]),
    masterclassHero() {
      const images = {
        female: 'masterclass_smartphone.jpg',
        male: 'masterclass_smartphone.jpg',
        unknow: 'masterclass_smartphone.jpg'
      }

      if (!this.user) return images.unknow

      return images[this.user.gender] || images.unknow
    },
    swiperOptions() {
      return {
        slidesPerView: this.slidesPerView,
        spaceBetween: this.spaceBetween,
        freeMode: true,
      }
    },
    allMasterclassIds() {
      return _get(this.$store.state, 'lesson.theme.allIds', [])
    },
    pendingMasterclasses() {
      if (this.getThemes.length > 0) {
        return this.sortMasterclassesByStatus(this.getThemes
        .filter(el => el && getThemePercentage(el.id) > 0)
        .sort((masterclass1, masterclass2) => masterclass1.order - masterclass2.order))
      }
      return []
    },
    pendingMasterclassesLess() {
      if (this.getThemes.length > 0) {
        const array = this.sortMasterclassesByStatus(this.getThemes
        .filter(el => el && getThemePercentage(el.id) > 0)
        .sort((masterclass1, masterclass2) => masterclass1.order - masterclass2.order))
        if (array.length > 2) array.length = 2
        return array
      }
      return []
    },
    notStartedMasterclasses() {
      if (this.getThemes.length > 0) {
        return this.getThemes
        .filter(el => el && !this.pendingMasterclasses.includes(el.id))
        // .map(el => this.getThemeById(el.id))
        .sort((masterclass1, masterclass2) => masterclass1.order - masterclass2.order)
      }
      return []
    },
    // Falilou Masterclass
    wineMasterclasses() {
      if (this.getThemes.length > 0) {
        return this.sortMasterclassesByStatus(this.getThemes
        .filter(el => el && this.getThemeById(el.id) && this.getThemeById(el.id).wineMaking)
        // .map(el => this.getThemeById(el.id))
        .sort((masterclass1, masterclass2) => masterclass1.order - masterclass2.order))
      }
      return []
    },
    wineMasterclassesLess() {
      if (this.getThemes.length > 0) {
        const array = this.sortMasterclassesByStatus(this.getThemes
        .filter(el => el && this.getThemeById(el.id) && this.getThemeById(el.id).wineMaking)
        // .map(el => this.getThemeById(el.id))
        .sort((masterclass1, masterclass2) => masterclass1.order - masterclass2.order))
        array.length = 2
        return array
      }
      return []
    },
    discoverCepageMasterclasses() {
      if (this.getThemes.length > 0) {
        return this.sortMasterclassesByStatus(this.getThemes
        .filter(el => el && this.getThemeById(el.id) && this.getThemeById(el.id).discoverCepage)
        // .map(el => this.getThemeById(el.id))
        .sort((masterclass1, masterclass2) => masterclass1.order - masterclass2.order))
      }
      return []
    },
    discoverCepageMasterclassesLess() {
      if (this.getThemes.length > 0) {
        const array = this.sortMasterclassesByStatus(this.getThemes
        .filter(el => el && this.getThemeById(el.id) && this.getThemeById(el.id).discoverCepage)
        // .map(el => this.getThemeById(el.id))
        .sort((masterclass1, masterclass2) => masterclass1.order - masterclass2.order))
        array.length = 2
        return array
      }
      return []
    },
    discoverRegionMasterclasses() {
      if (this.getThemes.length > 0) {
        return this.sortMasterclassesByStatus(this.getThemes
        .filter(el => el && this.getThemeById(el.id) && this.getThemeById(el.id).discoverRegion)
        // .map(el => this.getThemeById(el.id))
        .sort((masterclass1, masterclass2) => masterclass1.order - masterclass2.order))
      }
      return []
    },
    discoverRegionMasterclassesLess(){
      if (this.getThemes.length > 0) {
        const array = this.sortMasterclassesByStatus(this.getThemes
        .filter(el => el && this.getThemeById(el.id) && this.getThemeById(el.id).discoverRegion)
        // .map(el => this.getThemeById(el.id))
        .sort((masterclass1, masterclass2) => masterclass1.order - masterclass2.order))
        array.length = 2
        return array
      }
      return []
    },
    wineAndYouMasterclasses() {
      if (this.getThemes.length > 0) {
        return this.sortMasterclassesByStatus(this.getThemes
        .filter(el => el && this.getThemeById(el.id) && this.getThemeById(el.id).wineAndYou)
        // .map(el => this.getThemeById(el.id))
        .sort((masterclass1, masterclass2) => masterclass1.order - masterclass2.order))
      }
      return []
    },
    wineAndYouMasterclassesLess() {
      if (this.getThemes.length > 0) {
        const array = this.sortMasterclassesByStatus(this.getThemes
        .filter(el => el && this.getThemeById(el.id) && this.getThemeById(el.id).wineAndYou)
        // .map(el => this.getThemeById(el.id))
        .sort((masterclass1, masterclass2) => masterclass1.order - masterclass2.order))
        array.length = 2
        return array
      }
      return []
    },
  },
  methods: {
    isLocked(id) {
      return !this.hasAccessToContent(id)
    },
    updateSliderOptions() {
      this.slidesPerView = ['mobile', 'tablet'].includes(this.$mq) ? (window.innerWidth / 200 - 0.2) : (window.innerWidth / 350 - 0.5)
      this.spaceBetween = ['mobile'].includes(this.$mq) ? 10 : 30
    },
    t(key, params) {
      return this.$t(`masterclass.list.${key}`, params)
    },
    masterclassLock(id) {
      const masterclass = this.getThemeById(id)

      return masterclass.author && masterclass.author.fullName === 'PENDING' ? true : false
    },
    onTileClick(id) {
      if (id.id != null) {
        if (this.masterclassLock(id.id))
          return
        if (this.isLocked(id.id)) {
          return this.$router.push({
            name: 'shop-item',
            params: {
              type: 'masterclass',
              productId: id.id
            }
          })
        }
        this.$router.push({ name: 'theme', params: { themeId: id.id } })
      } else {
        if (this.isLocked(id)) {
          if (this.masterclassLock(id))
            return
          return this.$router.push({
            name: 'shop-item',
            params: {
              type: 'masterclass',
              productId: id
            }
          })
        }
        this.$router.push({ name: 'theme', params: { themeId: id } })
      }

    },
    sortMasterclassesByStatus(mc) {
      // 1. Masterclass started
      // 2. Masterclass with access
      // 3. Free masterclass
      // 4. Locked masterclass
      // 5. Available soon
      return mc.sort((a, b) => {
        if (a.author && a.author.fullName !== 'PENDING' && b.author && b.author.fullName === 'PENDING') return -1
        else if (a.author && a.author.fullName === 'PENDING' && b.author && b.author.fullName !== 'PENDING') return 1
        else {
          if (this.hasAccessToContent(a.id) && !this.hasAccessToContent(b.id)) {
            return -1
          } else if (!this.hasAccessToContent(a.id) && this.hasAccessToContent(b.id)) {
            return 1
          } else {
            if (getThemePercentage(a.id) > getThemePercentage(b.id)) return -1
            else if (getThemePercentage(a.id) < getThemePercentage(b.id)) return 1
            else {
              if (a.premium && !b.premium) return -1
              else if (!a.premium && b.premium) return 1
              else return 0
            }
          }
        }

        return 0
      })
    }
  },
  async created() {
    this.assertLogged()

    this.updateSliderOptions()
  },
  updated() {
    this.updateSliderOptions()
  }
}
</script>

<style lang="scss" scoped>
.LockedOverlay {
  display: block;
  float: left;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.4);
  justify-content: center;
  align-items: center;
  height: 150px;
  width: 145px;
  border-radius: 23px;
  margin-top: -150px;

  .Lock {
    height: 100px;
  }

  .Lock-Unavailable {
    height: 125px;
  }
}
.body {
  width: 100%;
}
.showMore {
  background: #F0CF65;
  border-radius: 23px;
  margin-top: -20px;
  width: 90px;
  padding: 10px;
  color: white;
  font-size: 17px;
}
.showLess {
  background: #F0CF65;
  border-radius: 23px;
  margin-top: 20px;
  position: relative;
  top: 20px;
  width: 100px;
  padding: 10px;
  color: white;
  font-size: 17px;
}
.titleMasterclass {
  margin: 20px;
  font-size: 20px;
  font-weight: 700;
}
.itemsMasterclass {
  margin: 10px;
}
.bodyMasterclass {
  display: flex;
  flex-wrap: wrap;
  padding-top: 20px;
  padding-bottom: 20px;
  justify-content: space-around;
  border-radius: 20px;
  box-shadow: 2px 3px 6px #b0b4cb;
  width: 100%;
}
.imageMasterclass {
  float: left;
  width: 145px;
  height: 150px;
  border-radius: 20px;
}
.masterclass {
  display: flex;
  flex-direction: column;
  margin: 20px;
  width: calc(100% - 40px);
  text-align: center;
  align-items: center;
}
.active {
  flex-direction: column-reverse;
}
.mq-header {
  margin-top: 50px;
}

.MasterclassList {
  padding-bottom: 60px;

  .SectionTitle {
    margin-top: 10px;
    margin-bottom: 30px;
  }

  .Swiper {
    padding: 0 10px;
  }
}

.ContentTile {
  display: inline-block;
  padding: 0 10px 10px 10px;
  box-sizing: border-box;
  vertical-align: top;
  
}

.List__Container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  @media screen and (max-width: 719px) {
    justify-content: center;    
  }
}

.picto {
  width: 150px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-top: 15px;
}

.picto-mobile {
  width: 60px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-top: 15px;
}

.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
}
</style>
